export default "__VITE_ASSET__TAs0C6ps__"